module.exports = __webpack_public_path__ + "static/media/typeface-logo-prod.ed255132.svg";